import React from 'react'
import "./index.css";

const DealsDetailsSection = ({ detailsData = {} }) => {
  const { heading, description1, description2 } = detailsData || {};

  return (
    <section className="deals-details-section">
      <div className="deals-details-inner">
        <div className="deals-details-left">
          {heading && <h2 className="details-heading">{heading}</h2>}
          {description1 && (
            <div
              className="details-copy"
              dangerouslySetInnerHTML={{ __html: description1 }}
            />
          ) }
        </div>

        <aside className="deals-details-right">
          {description2 && (
            <div
              className="details-disclaimer"
              dangerouslySetInnerHTML={{ __html: description2 }}
            />
          ) }
        </aside>
      </div>
    </section>
  )
}

export default DealsDetailsSection
